import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "product-updates",
    name: "Product updates",
    version: "0.1.0",
    tier: "addon",
    accent: "shop",
    dependsOn: ["sites", "products"],
    description: "Keep the till's product file right from head office: supplier price lists in, the right default supplier for every product, departments matched to the wholesaler's range, VAT fixed, the NON SCAN keys guarded, and products missing from head office or from some sites found. Every change is staged, approved and sent as head office's own import file, then ticked off when the next day's till file shows it.",
    permissions: {
        view: "See product updates and what has been sent to head office",
        stage: "Find and stage changes (costs, suppliers, departments, VAT)",
        approve: "Approve changes and download head office's files",
        settings: "Head office file settings and the NON SCAN targets",
    },
    grants: {
        "Head office": ["view", "stage", "approve", "settings"],
        "Area manager": ["view"],
    },
    tasks: [
        { key: "nonscan", title: "NON SCAN key changed", description: "A till's NON SCAN key (the price used for items that won't scan) isn't on its set price or VAT. Clears when the next till file shows it right, or until 8am once marked fixed in the back office.", level: "urgent", audience: "routed", clear: "fix", link: "/product-updates/nonscan", icon: "alert", sort: 5 },
        { key: "sent", title: "Product changes to import", description: "A file of product changes is ready for head office's back office. Clears when it's marked imported.", level: "action", audience: "routed", clear: "fix", link: "/product-updates/sent", icon: "upload", sort: 30, notify: false },
    ],
    nav: [
        { label: "Product updates", path: "/product-updates", section: "shop", tab: "Pricing", permission: "view", icon: "layers", order: 25, blurb: "Costs, suppliers, departments and VAT fixed via head office" },
        // Under the Shop settings cog (26/10/26), not a tenth chip on every Product updates page.
        { label: "Product updates settings", path: "/product-updates/settings", section: "shop", kind: "settings", permission: "settings", icon: "layers", order: 26, blurb: "Head office id, till group rules, wholesaler accounts, site columns" },
    ],
});
